import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../types';
import { initialState } from './slice';

const selectDomain = (state: RootState) => state.allotmentInvoicePdf || initialState;

export const selectAllotmentInvoicePdfLoadingMap = createSelector(
    [selectDomain],
    state => state.isLoadingMap,
);
